import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import NavCommon from "../../components/@navHeader";
import { VisitasComponent } from "./components/visitas.component";

const ParentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  margin-top: 115px;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;

  h3 {
    font-size: 24px;
    font-family: Inter;
    font-weight: 400;
    padding: 10px 0px;
  }
`;

export function Visitas() {
  const history = useHistory();

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: "/visitas", name: "Visitas" }]}
        showButtonNew
        onBack={() => {
          history.goBack();
        }}
        open
        onChangeActionNew={undefined}
      />
      <ParentContainer>
        <VisitasComponent />
      </ParentContainer>
    </>
  );
}
